import React from 'react'
import { Grid } from '@material-ui/core'

import MainLayout from '../components/Layout/MainLayout'

export default function HomePage() {
  return (
    <MainLayout dealerID={null} factoryID={null}>
      <Grid container>
        <Grid item xs={12}>
          Homepage
        </Grid>
      </Grid>
    </MainLayout>
  )
}
